import { createContext, useContext, useEffect, useState } from "react";
import api, { clearToken } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  useEffect(() => {
    api.get("/auth/me", { skipAuthRedirect: true }).then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    clearToken();
    setUser(false);
  };
  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
